export enum AccountDataFlags {
  /**
   * button loader
   */
  CHECK_EMAIL,
}
